import React from "react";

const FooterLayout = () => {

  return (
    <footer className="footer">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 order-last order-md-first">
                    <div className="copyright text-center text-md-start">
                        <p className="text-sm">
                            Product of Abox
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default FooterLayout;
